/**
 * WooCommerce quantity buttons.
 *
 * @package Astra Addon
 * @since 2.1.3
 */

window.addEventListener("load", function (e) {
    astrawpWooQuantityButtons();
});

(function () {
    let send = XMLHttpRequest.prototype.send
    XMLHttpRequest.prototype.send = function () {
        this.addEventListener('load', function () {
            astrawpWooQuantityButtons();
        })
        return send.apply(this, arguments)
    }
})();

/**
 * Astra WooCommerce Quantity Buttons.
 */
function astrawpWooQuantityButtons( quantitySelector )
{
    if ( ! quantitySelector ) {
        quantitySelector = '.qty';
    }

    let quantityBoxesWrap = document.querySelectorAll('div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)');

    for (let i = 0; i < quantityBoxesWrap.length; i++) {
        let e = quantityBoxesWrap[i];
        
        let quantityBoxes = e.querySelector(quantitySelector);
        
        if (quantityBoxes && 'date' !== quantityBoxes.getAttribute('type')
            && 'hidden' !== quantityBoxes.getAttribute('type')) {
            // Add plus and minus icons.
            let qty_parent = quantityBoxes.parentElement;
            qty_parent.classList.add('buttons_added');
            qty_parent.insertAdjacentHTML('afterbegin', '<a href="javascript:void(0)" class="minus">-</a>');
            qty_parent.insertAdjacentHTML('beforeend', '<a href="javascript:void(0)" class="plus">+</a>');
            let quantityEach = document.querySelectorAll('input' + quantitySelector + ':not(.product-quantity)');
            
            for ( let j = 0; j < quantityEach.length; j++ ) {
                let el = quantityEach[j];
                
                let min = el.getAttribute('min');
                
                if ( min && min > 0 && parseFloat(el.value) < min ) {
                    el.value = min;
                }
            }

            let plus_minus_obj = e.querySelectorAll('.plus, .minus');
            for (let l = 0; l < plus_minus_obj.length; l++) {
                let pm_el = plus_minus_obj[l];

                pm_el.addEventListener("click", function (ev) {

                    // Quantity.
                    let quantityBox = ev.target.parentElement.querySelector(quantitySelector);

                    // Get values.
                    let currentQuantity = parseFloat(quantityBox.value),
                    maxQuantity = parseFloat(quantityBox.getAttribute('max')),
                    minQuantity = parseFloat(quantityBox.getAttribute('min')),
                    step = quantityBox.getAttribute('step');

                    // Fallback default values.
                    if ( ! currentQuantity || '' === currentQuantity || 'NaN' === currentQuantity ) {
                        currentQuantity = 0;
                    }
                    if ( '' === maxQuantity || 'NaN' === maxQuantity ) {
                        maxQuantity = '';
                    }

                    if ( '' === minQuantity || 'NaN' === minQuantity ) {
                        minQuantity = 0;
                    }
                    if ( 'any' === step || '' === step || undefined === step || 'NaN' === parseFloat(step) ) {
                        step = 1;
                    }

                    // Change the value.
                    if ( ev.target.classList.contains('plus') ) {
                        if ( maxQuantity && ( maxQuantity === currentQuantity || currentQuantity > maxQuantity ) ) {
                            quantityBox.value = maxQuantity;
                        } else {
                            quantityBox.value = currentQuantity + parseFloat(step);
                        }
                    } else {
                        if ( minQuantity && ( minQuantity === currentQuantity || currentQuantity < minQuantity ) ) {
                            quantityBox.value = minQuantity;
                        } else if ( currentQuantity > 0 ) {
                            quantityBox.value = currentQuantity - parseFloat(step);
                        }
                    }

                    // Trigger change event.
                    let event = document.createEvent('HTMLEvents');
                    event.initEvent('change', true, false);
                    quantityBox.dispatchEvent(event);

                }, false);
            }
        }
    }
}